import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog/Dialog";
import ManagementService from "@/lib/services/management/ManagementService";
import { Loader2 } from "lucide-react";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  picInitial: string | null;
};

export function ViewRoomsDialog({ isOpen, onClose, picInitial }: Props) {
  const [rooms, setRooms] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isOpen && picInitial) {
      setLoading(true);
      ManagementService.getPICRooms(picInitial).then((data) => {
        setRooms(Array.isArray(data) ? data : []);
        setLoading(false);
      });
    }
  }, [isOpen, picInitial]);

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md bg-card border-border font-lregular text-foreground">
        <DialogHeader>
          <DialogTitle className="font-lsemibold">Rooms for {picInitial}</DialogTitle>
        </DialogHeader>
        <div className="py-2">
          {loading ? (
            <div className="flex justify-center py-8">
              <Loader2 className="animate-spin text-blue-500" />
            </div>
          ) : rooms.length > 0 ? (
            <div className="border rounded-lg overflow-hidden border-border max-h-[400px] overflow-y-auto">
              <table className="w-full text-sm">
                <thead className="bg-secondary/30 border-b border-border sticky top-0">
                  <tr>
                    <th className="px-4 py-3 text-left font-lsemibold">Room Code</th>
                    <th className="px-4 py-3 text-left font-lsemibold">Room Name</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-border">
                  {rooms.map((room) => (
                    <tr key={room.id} className="hover:bg-muted/30 transition-colors">
                      <td className="px-4 py-3 font-lmedium">{room.room_code}</td>
                      <td className="px-4 py-3 text-muted-foreground text-xs">
                        {room.room_name}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="text-center py-10 text-muted-foreground italic text-sm">
              No rooms assigned to this PIC.
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}